module.exports = __webpack_public_path__ + "img/11_fineStaff_jxy.3115c18a.png";